var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('cliente-direcciones-form',{attrs:{"direccion":_vm.direccion,"isUpdate":true,"loading":_vm.loading},on:{"close-dialog":function($event){return _vm.$emit('close-dialog')},"process-save":_vm.actualizarDireccion}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }